<template>
    <span ref="word" style="z-index:-1" v-bind:class="{'video-cut': isVideoCut, 'high':isConfidenceHigh, 'medium':isConfidenceMedium, 'low':isConfidenceLow}" :data-start="startTime" :data-end="endTime" :data-position="position" :data-confidence="confidence" >{{text}}</span>
  </template>
  
  <script>
  //:class="getConfidenceClass"
  //import storeHelper from '@/utils/storeHelper'
  //const storeModules = storeHelper.createHelpers(['editSession'])
  export default {
    name: 'WordComponent',
    props: ['originalStartTime', 'originalEndTime', 'originalText', 'phraseIndex', 'wordIndex', 'confidence', "isConfidence","isVideoCut"],
    components: {},
    data () {
      return {
        newStartTime: 0,
        newEndTime: 0,
        newText: ''
      }
    },
    methods: {
      updateStartTime (time) {
        this.newStartTime = time
      },
      updateEndTime (time) {
        this.newEndTime = time
      },
      updateText (time) {
        this.newEndTime = time
      },
      getText () {
        return this.$refs.word.innerText
      },
      getStartTime () {
        return this.startTime
      },
      getEndTime () {
        return this.endTime
      }
    },
    computed: {
      // getConfidenceClass(){
      //   const me = this;
  
      //   if(!me.isConfidence){
      //     return;
      //   }
  
      //   if(me.confidence >= 0.9){
      //     return 'high';
      //   }
      //   else if(me.confidence >= 0.7){
      //     return 'medium';
      //   }
      //   else{
      //     return 'low';
      //   }
      // },
      isConfidenceHigh(){
         const me = this;
  
         return me.isConfidence && me.confidence >= 0.9;
      },
      isConfidenceMedium(){
         const me = this;
  
         return me.isConfidence && me.confidence < 0.9 && me.confidence >= 0.7;
      },
      isConfidenceLow(){
         const me = this;
  
         return me.isConfidence && me.confidence < 0.7;
      },
      startTime () {
        const me = this
        return me.newStartTime || me.originalStartTime
      },
      endTime () {
        const me = this
        return me.newEndTime || me.originalEndTime
      },
      text () {
        const me = this
        return me.originalText
      },
      position () {
        const me = this
        return `${me.phraseIndex}:${me.wordIndex}`
      }
    }
  }
  </script>
  
  <style scoped>
  .high{
    /* color:#1d7b63 !important; */
  }
  .medium{
    color:#7f6514 !important;
  }
  .low{
   color:#cca120!important;
  }
  </style>
  